module.exports = __webpack_public_path__ + "media/images/brands/marque-ciate-0a09f79d35a8494260e84212864fe058.jpg";